import React, { useEffect, useState } from "react";
import { Box, Backdrop, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ProfileMainDataForm from "./ProfileMainDataForm";
import { useGetProfileInfoQuery } from "../../../middleware/usersApi";
import { useAppSelector } from "../../../hooks/redux";
import ButtonsField from "./ButtonsField";
import { useAction } from "../../../hooks/actions";
import EditProfileMainDataForm from "./EditProfileMainDataForm";
import "./styles/styles.css";

const Profile = () => {
  const { t } = useTranslation();
  const { setIsErrorRequest } = useAction();
  const { isSuccessSubmit } = useAppSelector((state) => state.settings);
  const [isEditedProfileData, setIsEditedProfileData] = useState(false);

  const token = useAppSelector((state) => state.users.token);

  const {
    data: profileData,
    isLoading: isLoadingProfileData,
    error: errorGetProfileData,
    refetch: refetchProfileData,
  } = useGetProfileInfoQuery(token, { skip: !token });

  useEffect(() => {
    setIsErrorRequest(errorGetProfileData);
  }, [errorGetProfileData]);

  useEffect(() => {
    if (isSuccessSubmit) {
      refetchProfileData();
    }
  }, [isSuccessSubmit]);

  if (isLoadingProfileData) {
    return (
      <Backdrop sx={{ color: "var(--white)", zIndex: 9999 }} open={isLoadingProfileData}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }
  return (
    <Box className="profile_container">
      <Box className="profile_container-header">
        <Typography className="title-page">
          {isEditedProfileData ? t("title_page:edit-profile") : t("title_page:profile")}
        </Typography>
        <ButtonsField
          isEditedProfileData={isEditedProfileData}
          setIsEditedProfileData={setIsEditedProfileData}
          token={token}
        />
      </Box>
      <Box className="scrolled-form">
        {!isEditedProfileData ? (
          <ProfileMainDataForm profileData={profileData} token={token} refetchProfileData={refetchProfileData} />
        ) : (
          <EditProfileMainDataForm
            profileData={profileData}
            token={token}
            setIsEditedProfileData={setIsEditedProfileData}
            refetchProfileInfo={refetchProfileData}
          />
        )}
      </Box>
    </Box>
  );
};

export default Profile;
